import Image from 'next/legacy/image';
import { useTranslation } from 'next-i18next';
import React from 'react';
import type { BannerItem } from '@/api/cms/types';
import { homeConfig } from './homeConfig';
import { rentingBenefitsData } from './homeData';
import RentingBenefitSlider from './RentingBenefitSlider';

export type RentingBenefitContentProps = {
  homeBannerData: BannerItem[] | null;
};

export default function RentingBenefitContent({
  homeBannerData,
}: RentingBenefitContentProps) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <section
      data-test-id="rentingBenefitContent"
      className="desktop:py-32 py-20"
    >
      <article className="max-w-content desktop:space-y-4 desktop:mb-20 mx-auto mb-6 flex-col space-y-3">
        <h2 className="text-title32 text-neutral-90 desktop:text-title48 text-center font-bold">
          {t('home:benefit.title')}
        </h2>
        <p className="text-body14 desktop:text-body16 text-neutral-60 text-center font-medium">
          {t('home:benefit.desc')}
        </p>
      </article>
      <div className="desktop:grid-cols-2 desktop:gap-0 grid grid-cols-1 gap-20">
        <div className="desktop:order-last relative flex items-center justify-center">
          {/* <Image
              src="/static/images/home/thuexedien.webp"
              alt=""
              layout="fill"
            /> */}
          {homeBannerData && homeBannerData.length > 0 ? (
            <RentingBenefitSlider
              homeBannerData={homeBannerData as BannerItem[]}
            />
          ) : null}
        </div>
        <div className="flex flex-col items-start space-y-12">
          {rentingBenefitsData.map((item, idx) => (
            <div key={idx} className="max-w-sm">
              <Image src={item.icon} alt="" width={80} height={80} />
              <p className="desktop:text-title24 desktop:font-bold desktop:mt-4 mt-3 text-left font-semibold text-black">
                {t(`home:benefit.${item.value}.value`)}
              </p>
              <p className="text-body14 text-neutral-60 desktop:text-body16 mt-2 text-left font-medium">
                {t(`home:benefit.${item.value}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
